import { Component, OnInit, OnDestroy, Input, Output, ViewChild, ElementRef } from '@angular/core';
import { FormBuilder, FormControl, FormArray, FormGroup, Validators, AbstractControl } from '@angular/forms';
import {MatDialog} from '@angular/material';
import {FileService} from "../../../_services/file.service";
import {RequestService} from "../../../_services/request.service";
import {DialogPdfComponent} from '../../profile/dialog-pdf/dialog.component';
import {RequestDialog} from "./request-dialog";
import {Router, ActivatedRoute, Params} from '@angular/router';

@Component({
  selector: 'pdf-request-component',
  templateUrl: './pdf.request.component.html',
  providers:[FileService,RequestService]
})
export class PDFRequestComponent implements OnInit, OnDestroy {
  @ViewChild('droppable1') droppable1: ElementRef;
  @ViewChild('droppable2') droppable2: ElementRef;

  @Input() prompt:string;
  @Input() tooltip:string;
  @Input() questionid:number;
  @Input() jsclassinit:any;
  @Input() questioninitmixin:any;
  @Input() value:any;
  @Input() disabled:boolean;
  @Input() required:boolean;

  validationMessages: any;
  formErrors:any;
  formSegment:FormGroup;
  subscriptions:any;
  filepath:string;
  filename:string;
  touched:boolean=false;
  requestEmail:string='';
  requestBody:string='';
  requestToken:string='';
  requestId:number|null|undefined=undefined;
  requestCreated:string='';
  requestPrettyDate:string='';
  loading:boolean=false;
  personid:number;
  appid:number;

  public getValue(){
    var v,value={},result={};
    if(!this.disabled) {
      if(!!this.requestEmail) {
        result['requestEmail']=this.requestEmail;
      }
      if(!!this.requestBody) {
        result['requestBody']=this.requestBody;
      }
      if(!!this.requestToken) {
        result['requestToken']=this.requestToken;
      }
      if(!!this.requestId) {
        result['requestId']=this.requestId;
      }
      if(!!this.requestCreated) {
        result['requestCreated']=this.requestCreated;
      }
      if(!!this.filepath) {
        result['filepath']=this.filepath;
      }
      if(!!this.filename) {
        result['filename']=this.filename;
      }
      v=this.formSegment.value;
      if(!!v && !!v.fileId) {
        result['fileId']=v.fileId;
      }
      if(!!this.questioninitmixin && !!this.questioninitmixin.attachableType) {
        result['attachableType']=this.questioninitmixin.attachableType;
      }
    }
    value[this.questionid]=result;
    return value;
  }

  constructor(
    private _fileService:FileService,
    private _requestService:RequestService,
    private activatedRoute: ActivatedRoute,
    public dialog: MatDialog
  ) {
    this.subscriptions=[];
  }

  isValid():boolean {
    if(this.required) {
      return !!this.filepath;
    }
    return true;
  }
  validate():boolean {
    this.touched=true;
    return this.isValid();
  }

  onDrop(files, evt, classobject?: any) {
      classobject.touched=true;
      classobject.loading = true;
      for (let i = 0; i < files.length; i++) {
          let ext = '';
          //console.log(files[i]);
          // Here, we simply log the Array of files to the console.
          let mimeType = files[i].type;
          ext = files[i].name.split('.').pop();
          //console.log(ext);
          const allowedMIMEType = ['application/pdf','image/jpeg','image/x-png','image/png'];
          if(allowedMIMEType.indexOf(mimeType)>= 0 ){
              classobject.filetype = ext;

              const body = {
                  attachableId: '',
                  file: files[i],
                  attachableType:classobject.questioninitmixin.attachableType
              };

              //console.log(body);

              classobject.subscriptions.push(classobject._fileService.uploadFile(body).subscribe(

                responsedata => {
                  var parsed=JSON.parse(responsedata._body);
                  //console.log(responsedata);
                  let fileId = parsed.data.fileId;
                  classobject.formSegment.controls["fileId"].setValue(fileId);

                  classobject.filename = files[i].name;

                  let filelink = parsed.data.filelink;
                  classobject.filepath = filelink;

                  classobject.loading = false;
                },

                error => {
                  classobject.loading = false;
                }

              ));

          } else {
              alert("File not allowed");
              classobject.loading = false;
          }
      }
  }

  changePdf(filepath) {
    const dialogRef = this.dialog.open(DialogPdfComponent, {
      height: '600px',
      data: { url: filepath }
    });
  }

  requestPdf() {
    const dialogRef = this.dialog.open(RequestDialog, {
      data: { questionid: this.questionid }
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result !== null) {
        this.makeRequest(result.email,result.body);
      }
    });
  }

  makeRequest(email,body) {
    this.loading=true;
    this._requestService.makeRequest(email,body,this.personid,this.appid,this.questionid).subscribe(
      (success)=>{
        this.loading=false;
        this.requestEmail=email;
        this.requestBody=body;
        this.requestToken=success.base62token;
        this.requestId=success.filerequestid;
        this.requestCreated=success.created;
        this.makePrettyDate();
      },
      (failure)=>{
        this.loading=false;
      }
    );
  }

  makeDroppable(element, callback,classObj) {
    var input = document.createElement('input');
    input.setAttribute('type', 'file');
    //input.setAttribute('multiple', 'true');
    input.style.display = 'none';

    input.addEventListener('change', function (e) {
      triggerCallback(e, classObj);
    });
    element.appendChild(input);

    element.addEventListener('dragover', function(e) {
      e.preventDefault();
      e.stopPropagation();
      element.classList.add('dragover');
    });

    element.addEventListener('dragleave', function(e) {
      e.preventDefault();
      e.stopPropagation();
      element.classList.remove('dragover');
    });

    element.addEventListener('drop', function(e) {
      e.preventDefault();
      e.stopPropagation();
      element.classList.remove('dragover');
      triggerCallback(e,classObj);
    });

    element.addEventListener('click', function() {
      input.value = null;
      input.click();
      //console.log(input);
    });

    function triggerCallback(e,obj) {
      var files;
      if(e.dataTransfer) {
        files = e.dataTransfer.files;
      } else if(e.target) {
        files = e.target.files;
      }
      callback.call(null,files,e,obj);
    }
  }

  makePrettyDate() {
    if(!!this.requestCreated) {
      var d=new Date(this.requestCreated);
      this.requestPrettyDate=new Intl.DateTimeFormat("en-US").format(d);
    }
  }

  ngOnInit() {
    var init={};
    init['fileId']=new FormControl();
    this.formSegment=new FormGroup(init);

    this.makeDroppable(this.droppable1.nativeElement, this.onDrop, this);
    this.makeDroppable(this.droppable2.nativeElement, this.onDrop, this);

    if(!!this.value) {
      if(!!this.value.filename) {
        this.filename=this.value.filename;
      }
      if(!!this.value.filepath) {
        this.filepath=this.value.filepath;
      }
      if(!!this.value.requestEmail) {
        this.requestEmail=this.value.requestEmail;
      }
      if(!!this.value.requestBody) {
        this.requestBody=this.value.requestBody;
      }
      if(!!this.value.requestToken) {
        this.requestToken=this.value.requestToken;
      }
      if(!!this.value.requestId) {
        this.requestId=this.value.requestId;
      }
      if(!!this.value.requestCreated) {
        this.requestCreated=this.value.requestCreated;
        this.makePrettyDate();
      }
      if(!!this.value.fileId) {
        init['fileId'].setValue(this.value.fileId);
      }
    }

    this.activatedRoute.params.subscribe((params: Params) => {
        this.personid=parseInt(params.personid,10);
        this.appid=parseInt(params.appid,10);
    });
  }

  ngOnDestroy() {
    var C;
    while(C=this.subscriptions.pop()) {
      C.unsubscribe();
    }
  }
}



// WEBPACK FOOTER //
// /home/aschmidt/websites/onefuturecv.org/onefuture-frontend/src/app/pages/questionnaire/elements/pdf.request.component.ts